import * as React from 'react';
import SendFeedbackContainer from '../utils/SendFeedbackContainer';
import strings from 'owa-strings/owa-common-strings';
import { ControlIcons } from 'owa-addins-icons';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';

let styles = require('./InClientStorePanel.scss');

export default class InClientStorePanel extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            isPanelOpen: true,
        };
    }

    public setPanelOpen() {
        this.setState({ isPanelOpen: true });
    }

    public openSendFeedbackCompose() {
        SendFeedbackContainer.sendFeedback();
    }

    render() {
        {
            if (isFeatureEnabled('addin-centerAlignedICSEnabled')) {
                return (
                    <Modal
                        isOpen={this.state.isPanelOpen}
                        onDismiss={() => this.setState({ isPanelOpen: false })}>
                        <div className={styles.container}>
                            <IconButton
                                className={styles.closeButton}
                                onClick={() => {
                                    this.setState({ isPanelOpen: false });
                                }}
                                iconProps={{ iconName: ControlIcons.Cancel }}
                            />
                            <iframe
                                src={this.props.storeUrl}
                                title=""
                                className={styles.inClientStoreIFrameCenter}
                                frameBorder={0}
                            />
                        </div>
                        {isFeatureEnabled('addin-inClientStoreSendFeedbackEnabled') && (
                            <div className={styles.FeedbackCommandBarCenter}>
                                <div onClick={this.openSendFeedbackCompose}>
                                    {strings.sendFeedback}
                                </div>
                            </div>
                        )}
                    </Modal>
                );
            } else {
                return (
                    <Panel
                        isOpen={this.state.isPanelOpen}
                        type={PanelType.largeFixed}
                        isLightDismiss={true}
                        focusTrapZoneProps={{ forceFocusInsideTrap: false }}
                        // tslint:disable-next-line:jsx-no-lambda
                        onDismiss={() => this.setState({ isPanelOpen: false })}
                        className={styles.inClientStorePanelContainer}>
                        <iframe
                            src={this.props.storeUrl}
                            title=""
                            className={styles.inClientStoreIFrame}
                            frameBorder={0}
                        />
                        {isFeatureEnabled('addin-inClientStoreSendFeedbackEnabled') && (
                            <div className={styles.FeedbackCommandBar}>
                                <div onClick={this.openSendFeedbackCompose}>
                                    {strings.sendFeedback}
                                </div>
                            </div>
                        )}
                    </Panel>
                );
            }
        }
    }
}
